import { WorkModeType } from "@evidenceb/athena-common/interfaces/Workmode";
import type {
  AthenaEvent,
  SessionActionEventData,
} from "@evidenceb/athena-event-storage-schemas";
import type { AthenaEventStream } from "@evidenceb/athena-events-tools";
import { v4 } from "uuid";

export const workModeTypeToEventWorkmode = (workmode: WorkModeType) => {
  switch (workmode) {
    case WorkModeType.Duo:
      return "duo";
    case WorkModeType.SoloAI:
      return "solo-ai";
    case WorkModeType.Playlist:
      return "playlist";
    case WorkModeType.Experimentation:
      return "experimentation";
    case WorkModeType.Tuto:
      return "tuto";
    case WorkModeType.Test:
      console.log(
        "WorkModeType.Test is not supported. Outputting instead 'tuto'.",
      );
      return "tuto";
    case WorkModeType.Workshop:
      return "workshop";
    case WorkModeType.StandaloneAdaptiveTest:
      return "standalone-adaptive-test";
    case WorkModeType.Revision:
      return "revision";
    default:
      console.log(`${workmode} is not supported. Outputting instead 'tuto'.`);
      return "tuto";
  }
};

export const eventWorkmodeToWorkModeType = (
  eventWorkmode:
    | "solo-ai"
    | "revision"
    | "standalone-adaptive-test"
    | "tuto"
    | "duo"
    | "playlist"
    | "experimentation"
    | "workshop",
): WorkModeType => {
  return {
    duo: WorkModeType.Duo,
    "solo-ai": WorkModeType.SoloAI,
    playlist: WorkModeType.Playlist,
    experimentation: WorkModeType.Experimentation,
    tuto: WorkModeType.Tuto,
    workshop: WorkModeType.Workshop,
    "standalone-adaptive-test": WorkModeType.StandaloneAdaptiveTest,
    revision: WorkModeType.Revision,
  }[eventWorkmode];
};

export function isAIShowMessageEvent(
  athenaEvent: AthenaEvent<any, any>,
): athenaEvent is AthenaEvent<"ai", "AIShowMessageEvent"> {
  return athenaEvent.type === "AIShowMessageEvent";
}

export function publish_session_event(
  athenaEventStream: AthenaEventStream,
  userId: string,
  sessionId: string,
  app: string,
  data: SessionActionEventData,
) {
  const event: AthenaEvent<"session", "SessionActionEvent"> = {
    id: v4(),
    createdAt: new Date().toISOString(),
    userId: userId,
    sessionId: sessionId,
    app: app,
    categoryData: { online: true },
    type: "SessionActionEvent",
    data: data,
  };

  athenaEventStream.publish(event);
}
